import React, { useContext, useMemo } from 'react';
import Progress from 'components/progress';
import ShipCard from 'components/ShipCard';
import FirebaseContext from 'components/Firebase/context';
import { useShips } from 'hooks/use-ships';
import { Collection } from 'atoms/collection';
import { useCollection } from 'hooks/use-collection';
import * as styles from '../Home/styles.module.css';
import styled from 'styled-components/macro';

const StyledLayout = styled.div`
  padding: 1rem;
  padding-top: 2rem;
  display: flex;
  align-items: flex-start;

  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
`;

export function RetrofitsScreen() {
  const { firebase }: any = useContext(FirebaseContext);
  const ships = useShips();
  const [collection, setCollection] = useCollection();

  const chineseRetrofits = useMemo(
    () => ships?.filter((ship) => ship.retrofit === 'cn') || [],
    [ships],
  );
  const retrofitList = useMemo(
    () => ships?.filter((ship) => ship.retrofit === 'all') || [],
    [ships],
  );

  const myRetrofitList = useMemo(
    () =>
      ships?.filter((ship) => collection?.data.retrofits.includes(ship.id)) ||
      [],
    [collection?.data.retrofits, ships],
  );

  const handleToggleShip = async (id: string) => {
    const next = {
      ...collection,
      data: {
        ...collection?.data,
        retrofits: getNextShips(collection?.data?.retrofits, id),
      },
    };

    const updateDatabase = async () => {
      if (!collection) return;

      const db = firebase.firestore();
      const collectionRef = db.collection('collections');
      await collectionRef.doc(collection.id).set(next.data);
    };

    setCollection(next as Collection);
    await updateDatabase();
  };

  return (
    <StyledLayout>
      <div style={{ flex: 1 }}>
        <div style={{ margin: 'auto', width: 500 }}>
          <Progress
            current={myRetrofitList.length}
            total={retrofitList.length}
          />
        </div>

        <div className={(styles as any).ShipList}>
          {retrofitList.map(
            (ship) =>
              ship.rarity !== 'Unreleased' && (
                <ShipCard
                  key={ship.id}
                  id={ship.id}
                  icon={ship.icon}
                  name={ship.name}
                  rarity={(ship.rarity as number) + 1}
                  existInCollection={(name: string) =>
                    myRetrofitList.find((ship) => ship.name === name)
                  }
                  onClickById={() => handleToggleShip(ship.id)}
                  retrofitable={ship.retrofit === 'all'}
                  eventDrops=""
                />
              ),
          )}
        </div>

        <h2 style={{ textAlign: 'center', marginBottom: -24 }}>Coming Soon</h2>
        <div className={(styles as any).ShipList}>
          {chineseRetrofits.map((ship) => (
            <ShipCard
              key={ship.id}
              id={ship.id}
              icon={ship.icon}
              name={ship.name}
              rarity={(ship.rarity as number) + 1}
              existInCollection={() => false}
              retrofitable={ship.retrofit === 'all'}
              eventDrops=""
              onClickById={null}
            />
          ))}
        </div>
      </div>
    </StyledLayout>
  );
}

function getNextShips(ships: string[] = [], name: string) {
  if (ships.find((s) => s === name)) {
    return ships.filter((s) => s !== name);
  } else {
    return ships.concat(name);
  }
}
